import { type ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  icon?: IconName;
  brand?: boolean;
  action?: ReactNode;
}

export function EmptyState({ title, description, icon, brand, action }: EmptyStateProps) {
  const cls = 'empty-state';
  // "Calm pass": anche la variante brand e' liquid — tile con monogramma M
  // (nessun fondale cosmico: le varianti aurora/hero sono state rimosse).
  if (brand) {
    return (
      <div className={cls}>
        <div className="empty-state-icon">
          <img src="/logos/m-ink.svg" alt="" style={{ height: 16, width: 'auto', display: 'block', opacity: 0.9 }} />
        </div>
        <div className="empty-state-title">{title}</div>
        {description && <div className="empty-state-desc">{description}</div>}
        {action}
      </div>
    );
  }
  return (
    <div className={cls}>
      <div className="empty-state-icon">
        <Icon name={icon ?? 'check'} size={28} />
      </div>
      <div className="empty-state-title">{title}</div>
      {description && <div className="empty-state-desc">{description}</div>}
      {action}
    </div>
  );
}
